jQuery.noConflict();

var povprasevanje;
var price = 0;
var insurance = 0;


(function($) {

    $(document).ready(function(){


        //XSS fix
        $('#trip-search-string').on('input', function() {

            var regex = /^[a-zA-ZčšžČŠŽđćĐĆ]*$/;

            if (!regex.test($(this).val())) {
                $(this).val($(this).val().replace(/[^a-zA-ZčšžČŠŽđćĐĆ\s]/g, ''));
            }
        });


        //Regenerates cookiebot 
        (function () {
            $('.change-cookie').on('click', function (e) {
                e.preventDefault();
                CookieConsent.renew();
            })
        })();



        //Emigma Accessibility Panel START

        //Ikona + Panel
        $('#a11y-icon').on('click', function (e) {
            $("#emigma_a11y_toolbar").toggleClass('active');
        });

        
        let $body = $('body');
        let $html = $('html');


        $('#grayscale').on('click', function (e) {
            $html.toggleClass('grayscale');

            if(localStorage.getItem('grayscale') === '1') {
                localStorage.setItem('grayscale','0');
            }
            else {
                localStorage.setItem('grayscale','1');
            }


        });

        $('#contrast').on('click', function (e) {            
            $(this).find('span').toggleClass("active");         
            $body.toggleClass('accessible');
            $html.toggleClass('accessible');


            if(localStorage.getItem('contrast') === '1') {
                localStorage.setItem('contrast','0');
            }
            else {
                localStorage.setItem('contrast','1');
            }

   
        });

        $('#fontsize').on('click', function (e) {
            $(this).find('span').toggleClass("active"); 
            $html.toggleClass('acc-font');

            if(localStorage.getItem('fontsize') === '1') {
                localStorage.setItem('fontsize','0');
            }
            else {
                localStorage.setItem('fontsize','1');
            }

        });

        $('#links').on('click', function (e) {
            $(this).find('span').toggleClass("active"); 
            $('body').toggleClass('underline-links');


            if(localStorage.getItem('links') === '1') {
                localStorage.setItem('links','0');
            }
            else {
                localStorage.setItem('links','1');
            }


        });

        $('#reset').on('click', function (e) {

            //clear cookies/remove classes
            $('body').removeClass('underline-links');
            $html.removeClass("grayscale"); 
            $html.removeClass('acc-font');
            $body.removeClass('accessible');
            $html.removeClass('accessible');


            //Reset text color
            $('#links').find('span').removeClass("active"); 
            $('#contrast').find('span').removeClass("active"); 
            $('#grayscale').find('span').removeClass("active"); 
            $('#fontsize').find('span').removeClass("active"); 

            localStorage.setItem('links','0');
            localStorage.setItem('fontsize','0');
            localStorage.setItem('contrast','0');
            localStorage.setItem('grayscale','0');


        });



        (function() {
            if(localStorage.getItem('grayscale') === '1') {
                $html.toggleClass('grayscale');
            }
            else {
                $html.removeClass('grayscale');
            }
            

            if(localStorage.getItem('contrast') === '1') {
                $body.toggleClass('accessible');
                $html.toggleClass('accessible');

                $('#contrast').find('span').addClass("active"); 


            } else {
                localStorage.removeItem('contrast');
            }

            if(localStorage.getItem('fontsize') === '1') {
                $('#fontsize').find('span').toggleClass("active"); 
                $html.toggleClass('acc-font');

                $('#fontsize').find('span').addClass("active"); 
            } else {
                localStorage.removeItem('fontsize');
            }

            if(localStorage.getItem('links') === '1') {
                $('#links').find('span').toggleClass("active"); 
                $('body').toggleClass('underline-links');
            } else {
                localStorage.removeItem('links');
            }


        })();

        //A11Y END




        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        $(".gallery-icon a:not(.link)").fancybox();

        (function () {
            $('.filter-control').on('change', function () {
                $(this).closest('form').submit();
            });
        })();


        class Cart {
            constructor(passengerCount, basePrice) {
                this.passengerCount = passengerCount;
                this.basePrice = basePrice;
                this.price = basePrice;
                this.zavarovanjeFixed = $('#total').data('zavarovanje');
                this.zavarovanjePercentage = $('#total').data('percentage') / 100;
                this.zavarovanjeTax = $('#total').data('zav-tax') / 100;
                this.zavarovanjeBreakpoint = $('#total').data('limit');
                this.available = $('#available').val();
            }

            addPassenger() {

                // console.log('add passenger called');
                // console.log(this.available);
                // console.log(this.passengerCount);

                if (this.available > this.passengerCount) {
                    // console.log('condition met');
                    this.passengerCount++;
                    this.recalculate();
                }

                // console.log('end of add passenger');

            }

            removePassenger() {
                this.passengerCount--;
                this.recalculate();
            }


            // updatePassengerPrice() {
            //     $('.passenger').each(i, v => {
            //         console.log($(i));
            //     });
            // }

            recalculate() {
                // this.price = this.basePrice * this.passengerCount;
                this.price = 0;

                // console.log($('.departure-select'));
                let tempPrice = 0;
                let temp;
                $('.departure-select').each(function (i, element) {
                    temp = $(element).find(':selected').data('price');
                    tempPrice += parseInt(temp)
                });
                if (!tempPrice) {
                    this.price = this.basePrice * this.passengerCount;
                } else {
                    this.price = tempPrice;
                }

                let addonsPrice = 0;
                $('.doplacilo').each(function (k, i) {
                    let $item = $(i);
                    if ($item.is(':checked') && $item.data('price')) {
                        addonsPrice += parseInt($item.data('price'));
                    }
                });



                this.price = this.price + addonsPrice;


                //Zavarovanje
                $('.zavarovanje-label').removeClass('active');
                if (this.price > this.zavarovanjeBreakpoint) {
                    $('#zav-percentage').addClass('active');
                } else {
                    $('#zav-fixed').addClass('active');
                }

                if (this.price > this.zavarovanjeBreakpoint) {
                    let zavarovanje = this.price*this.zavarovanjePercentage;
                    this.totalZavarovanje = zavarovanje*this.zavarovanjeTax;
                    this.totalZavarovanje = zavarovanje;
                } else {
                    this.totalZavarovanje = this.zavarovanjeFixed;
                }

                let odpovedniVal = Math.round((this.totalZavarovanje + Number.EPSILON) * 100) / 100;

                $('.custom-odpovedni').html(odpovedniVal.toString().replace("/./g", ','));

                if ($('#zavarovanjeDa').is(':checked')) {
                    this.price += this.totalZavarovanje;
                }

                $('#price-control').val(Math.round((this.price + Number.EPSILON) * 100) / 100);

                return this.price;
            }
        }



        (function () {
            const $passengerCount = $('#passengerCount');
            let count = parseInt($passengerCount.val());
            let $primaryPassenger = $('#primary-passenger');
            let $payerData = $('#payer-wrapper .form-control');
            const $passengersWrapper = $('#passengers-wrapper');
            let tripId = $passengersWrapper.data('trip-id');
            let $total = $('#total');
            let total = $total.val();
            let $totalCostWrapper = $('#total-cost');
            let duration = $('#duration').val();
            let available = $('#available').val();


            let cart = new Cart(1, total);


            $(document).on('click', '.remove-passenger', function (e) {
                e.preventDefault();
                cart.removePassenger();
                $(this).closest('.passenger').remove();
                count--;
                $passengerCount.val(count).trigger('change');
                iplus_recalculate();

            });

            $('.add-passenger').on('click', function (e) {

                // console.log('ADD PASSENGER CLICKED');
                // console.log(available);
                // console.log($passengerCount.val());


                if (parseInt(available) > parseInt($passengerCount.val())) {

                    // console.log('BASIC CONDITION MET');

                    e.preventDefault();
                    cart.addPassenger();
                    count++;
                    $passengerCount.val(count).trigger('change');




                    let data = {
                        'count': count,
                        'id': parseInt(tripId)
                    };

                    ajaxHelper(data, 'add_passenger').then((response) => {
                        $passengersWrapper.append(response);
                        iplus_recalculate();
                    }, (response) => {
                        console.log(response);
                    });
                }

            });

            //Duplicate payer data to primary passenger on checkbox change
            //If checkbox is not checked clear the inputs of the primary passenger
            $('#passengerPayer').on('change', function () {
                let $that = $(this);
                let dataTarget;
                let $item;
                if ($that.is(':checked')) {                  

                    $('#primary-passenger .placnik-badge').removeClass('d-none');

                    $("label[for='passengerPayer']").addClass('btn-dark');
                    $("label[for='passengerPayer']").removeClass('btn-primary');
                    

                    $payerData.each(function (k, v) {
                        $item = $(v);
                        dataTarget = $item.data('item');
                        dataTarget = $(v).data('item');

                        $primaryPassenger.find('.form-control[data-item="'+dataTarget+'"]').val($item.val()).trigger('change');

                    })
                } else {
                    $primaryPassenger.find('input, select').val('').trigger('change');
                    $('#primary-passenger .placnik-badge').addClass('d-none');
                    $("label[for='passengerPayer']").addClass('btn-primary');
                    $("label[for='passengerPayer']").removeClass('btn-dark');
                }
            });

            $passengerCount.on('change', function () {
                if (duration > 1) {
                    let count = parseInt($passengerCount.val());

                    if (count > 1) {
                        $('#room-config').show();

                        let data = {
                            'count': count,
                            'id': parseInt(tripId)
                        };

                        ajaxHelper(data, 'rooms').then((response) => {
                            // $passengersWrapper.append(response);
                            $('#room-config-inner').html(response);
                        }, (response) => {
                            console.log(response);
                        });
                    } else {
                        $('#room-config').hide();
                        $('#room-config-inner').html('');
                    }

                }


            });


            //Any form change triggers cart recalc method and updates price html
            /*$('#cart-form').on('change', function () {
                cart.recalculate();

                updatePrice();
            });*/

            /*$('.departure-select').on('change', function() {
                iplus_recalculate();
                console.log('lala');
            });*/

            $('html').on('change', '.departure-select, .form-check-input', function() {
                iplus_recalculate();
            });

            function iplus_recalculate() {
                let form = $('#cart-form');
                $.ajax({
                    type: 'post',
                    dataType: 'json',
                    url: localize.ajaxurl,
                    async: false,
                    data: {action: 'calculate_trip_price', form: form.serialize()},
                    success: function(response) {
                        $('.insurance-card').css('display', 'block');
                        $('.custom-odpovedni').html(response.insurance_price);
                        let zavarovanje = ($("input[name=zavarovanje]:checked").val());
                        if(zavarovanje === 'Da') {
                            $('#total-cost').html(response.total_price);
                            $('#price-control').val(response.total_price);
                        } else {
                            $('#total-cost').html(response.without_insurance)
                            $('#price-control').val(response.without_insurance);
                        }
                    }
                })
            }

            $/*('.price-test').on('click', function(e) {
                e.preventDefault();
                let form = $('#cart-form');
                $.ajax({
                    type: 'post',
                    dataType: 'json',
                    url: localize.ajaxurl,
                    data: {action: 'calculate_trip_price', form: form.serialize()},
                    success: function(response) {
                        console.log('dela');
                        console.log(response);
                    }
                })
            })*/

            function updatePrice() {
                $totalCostWrapper.html((cart.price).toFixed(2).replace(".", ","));
            }

        })();


        //Menu fixer
        // $(window).scroll(menuFixer);
        //
        // function menuFixer() {
        //     let scroll = $(window).scrollTop(),
        //         $body = $('body');
        //
        //     if (scroll >= 50) {
        //         $body.addClass('nav-fixed');
        //     } else {
        //         $body.removeClass('nav-fixed');
        //     }
        // }
        // menuFixer();

        //Flatpickr calendar
        (function () {

            let lang = localize.lang,
                $startDate = $('#start-date'),
                $endDate = $('#end-date'),
                $filtersDate = $('.home-filters-wrapper .s-date');

            let $rentStartDate = $('.rent-s-date'),
                $rentEndDate = $('.rent-e-date');

            if($startDate.length > 0) {

                $startDate.flatpickr({
                    dateFormat: "d.m.Y",
                    locale: lang,
                    allowInput: true
                });
            }

            if($endDate.length > 0) {

                $endDate.flatpickr({
                    dateFormat: "d.m.Y",
                    locale: lang,
                    allowInput: true
                });
            }


            if($filtersDate.length > 0) {

                $filtersDate.flatpickr({
                    dateFormat: "d.m.Y",
                    locale: lang,
                    allowInput: true,
                    position: 'below center',
                    minDate: "today"
                });
            }



            if($rentStartDate.length > 0) {

                $rentStartDate.flatpickr({
                    dateFormat: "d.m.Y",
                    locale: lang,
                    allowInput: true,
                    position: 'below center',
                    minDate: "today"
                });
            }


            if($rentEndDate.length > 0) {

                $rentEndDate.flatpickr({
                    dateFormat: "d.m.Y",
                    locale: lang,
                    allowInput: true,
                    position: 'below center',
                    minDate: "today"
                });
            }

        })();

        (function () {
            let $timeInput = $('#cas-odhoda-input');

            $('.time-select-radio').on('click', function () {
                $timeInput.val($(this).data('time'));
            });
        })();

        (function () {
            $('.masonry').masonry({
                columnWidth: '.grid-sizer',
                itemSelector: '.type-poslovalnica',
                gutter: 30
            });
        })();

        (function () {
            const checkVal = function() {
                let $that = $(this);
                if ($that.val()) {
                    $that.addClass('active');
                } else {
                    $that.removeClass('active');
                }
            };

 
            $('.form-control, .gfield input').on('change', checkVal);
            $('.gfield input').trigger('change');
        })();

        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if ( ! data ) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action' : action,
                        'data' : data
                    },
                    type: 'POST',
                    success: function( response ) {
                        if ( response ) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }



        $(".posts-carousel").owlCarousel(
            {
                loop:true,
                nav:true,
                // center:true,
                items: 3,
                dots: false,
                mouseDrag: false,
                autoplay: false,
                margin: 16,
                // navContainer: $('.custom-nav'),
                navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
                responsive:{
                    0:{
                        items:1,
                        nav:true
                    },
                    760:{
                        items:3,
                        nav:true
                    },
                }
            }
        );



        $(".mm").owlCarousel(
            {
                loop:true,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                // center:true,
                items: 1,
                dots: true,
                nav:false,
                mouseDrag: false,
                autoplay: false,
                margin: 16,
                dotsContainer: $('.custom-nav'),
                // navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
                // responsive:{
                //     0:{
                //         items:1,
                //         nav:true
                //     },
                //     760:{
                //         items:3,
                //         nav:false
                //     },
                // }
            }
        );




        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });


        (function () {
            let sTrigger = $('#search-trigger'),
                sWrapper = $('#search-wrapper'),
                $body = $('body'),
                $overlay = $('.overlay'),
                $close = sWrapper.find('.close');

            sWrapper.open = false;
            sWrapper.toggler = function(){
                this.toggleClass('active');
                $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                sWrapper.open = !sWrapper.open;
            };
            sWrapper.closer = function() {
                this.removeClass('active');
                $body.removeClass('overlay-active').removeClass('prevent-scroll');
                sWrapper.open = false;
            };

            sTrigger.on('click', function (e) {
               e.preventDefault();
               sWrapper.toggler();
            });



            $close.add($overlay).on('click', function (e) {
                e.preventDefault();
               sWrapper.closer();
            });
        })();




        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }



        //These will be updated on window.resize
        //If you want an element to have any of its properties
        //calculated dynamically, please push it to this array in object format
        //Structure of object should be:
        /*
        {
            'element': $('#element'),
            'property': 'padding-left',
            'callback': calcFluidPadding
        }
        */
        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }


        //Gforms
        (function () {
            $('ul.gfield_radio input').on('click', function() {
                let that = $(this);
                that.closest('.gfield_radio').find('li').removeClass('checked');
                that.closest('li').addClass('checked');
            });

            if( window.gform ) {


                gform.addFilter( 'gform_datepicker_options_pre_init', function( options, formId, fieldId ) {

                    var className = 'datepicker-clean';

                    if( ! $( '#input_' + formId + '_' + fieldId ).parents( 'li.gfield' ).hasClass( className ) ) {
                        return options;
                    }


                    var beforeShow = options.beforeShow,
                        onClose    = options.onClose;

                    options.numberOfMonths = 2;
                    options.changeMonth = false;
                    options.changeYear = false;
                    options.showOtherMonths = true;
                    options.dayNamesMin = [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ];
                    options.beforeShow = function(textbox, instance) {
                        beforeShow();
                        $( '#ui-datepicker-div' ).addClass( className );

                    };
                    options.onClose = function() {
                        onClose();
                        var closeInterval = setInterval( function() {
                            var $dp = $( '#ui-datepicker-div' );
                            if( ! $dp.is( ':visible' ) ) {
                                $dp.removeClass( className );
                                clearInterval( closeInterval );
                            }
                        }, 100 );
                    };

                    return options;
                } );

            }
        })();


        (function () {

            // if (!isMobile){
                let $frame = $('.frame'),
                    $scrollbar = $('.o-scrollbar');

                if ($frame.length > 0) {
                    dynamicElements.push({
                            'element': $frame,
                            'property': 'padding-left',
                            'callback': calcFluidPadding
                        }
                    );

                    $frame.css('padding-left', calcFluidPadding());

                    new Sly($frame, {
                        horizontal: 1,
                        itemNav: 'basic',
                        smart: 0,
                        mouseDragging: 1,
                        touchDragging: 1,
                        releaseSwing: 0,
                        speed: 300,
                        dragHandle: 1,
                        dynamicHandle: 1,
                        scrollBar: $scrollbar,
                        cycleBy: 'items',
                        clickBar: true,
                    }).init();
                }
            // }

        })();

        $(window).on('resize', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');

             return ($( 'body' ).width() - $container.width()) / 2;
        }


        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.header-container'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }



        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();



        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        //language switcher
        (function () {

            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len =   this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        }  else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

        })();

    });

})( jQuery );
